
export const ExportCampaignTypes = {
    notSet: 0,
    sales: 1,
    service: 2,
    conquest: 3,
    callCenter: 4,
    other: 5,
};
